/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ElementClassName} from './ElementClassName';
import {
  ElementClassNameFromJSON,
  ElementClassNameFromJSONTyped,
  ElementClassNameToJSON
} from './ElementClassName';

/**
 *
 * @export
 * @interface BaseElementOut
 */
export interface BaseElementOut {
  /**
   *
   * @type {string}
   * @memberof BaseElementOut
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof BaseElementOut
   */
  name: string;
  /**
   *
   * @type {ElementClassName}
   * @memberof BaseElementOut
   */
  type: ElementClassName;
  /**
   *
   * @type {boolean}
   * @memberof BaseElementOut
   */
  deletable?: boolean;
}

/**
 * Check if a given object implements the BaseElementOut interface.
 */
export function instanceOfBaseElementOut(value: object): value is BaseElementOut {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function BaseElementOutFromJSON(json: any): BaseElementOut {
  return BaseElementOutFromJSONTyped(json, false);
}

export function BaseElementOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BaseElementOut {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    type: ElementClassNameFromJSON(json['type']),
    deletable: json['deletable'] == null ? undefined : json['deletable']
  };
}

export function BaseElementOutToJSON(value?: BaseElementOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    type: ElementClassNameToJSON(value['type']),
    deletable: value['deletable']
  };
}
